export const MAX_LISTINGS = 3;
export const MAX_SELL_REQUESTS = 3;

export const STEPS = {
  SELECT_LISTINGS: 0,
  ASSIGN_SELL_REQUESTS: 1,
  PX_SUMMARY: 2,
  PAYMENTS: 3,
  INVOICE: 4,
  COMMISSIONS: 5,
  INTERNAL_DETAILS_AND_COSTS: 6,
  TRACKING_NUMBER: 7,
};

export const PAYMENT_DIALOG = {
  STEPS: {
    QUESTION: 'question',
    CONFIRMATiON: 'confirmation',
  },
  DECISIONS: {
    CANNOT_DECIDE: 'cannot_decide',
    UPDATE_LISTING_PRICE: 'update_listing_price',
    CONFIRM: 'confirm',
  },
}


